
export const env = {
  REACT_APP_REDEEM_BASEURL:
    "https://stage-gamificationredemption.rewardrally.in",
  REACT_APP_GAMIFICATION_BASEURL:
    "https://stage-gamificationapi.rewardrally.in",
  BLOB_URL: "https://stagegamificationui.blob.core.windows.net",
  CONTAINER_PATH: "sandbox-assets",
};
